import { Component, OnInit } from '@angular/core';
import {CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import { ServicioFirebaseService } from 'src/app/servicios/servicio-firebase.service';
///variable de jquey para modal//
declare var $: any;
@Component({
  selector: 'app-editorsecuencia',
  templateUrl: './editorsecuencia.component.html',
  styleUrls: ['./editorsecuencia.component.css']
})
export class EditorsecuenciaComponent implements OnInit {
  public titulo:string="";
  public descripcion:string="";
  public descripcionsecuencia:string="";
  algo: boolean = true;
  nuevo_paso: string = "";
  pasos = [
    
  ];
  constructor(private servicio:ServicioFirebaseService) { }

  ngOnInit() {
  }
  crearPaso() {
    this.pasos.push(this.nuevo_paso);
    this.nuevo_paso="";
  }
  
  registrarActividad() {
    this.servicio.afAuth.authState.subscribe(res => {
      if (res) { 
       this.servicio.crearNuevaActividadSecuencia(res.uid,"secuencia",this.titulo,this.descripcion,this.descripcionsecuencia,this.pasos).then(res=>{
        this.showModal();
       })
      }
    })
  }
  drop(event: CdkDragDrop<string[]>) {
    if (this.algo) {
      if (event.previousContainer === event.container) {
        moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
      } else {
        transferArrayItem(event.previousContainer.data,
                        event.container.data,
                        event.previousIndex,
                        event.currentIndex);
      }
    }
  }
  showModal():void {
    $("#myModal").modal('show');
  }


}
